import React from "react";

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>
    ),
    title: "Compact by Design",
    desc: "Engineered for locations with limited installation space.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
    ),
    title: "Fast Turnaround Charging",
    desc: "Reduce vehicle downtime and keep operations moving.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
    ),
    title: "Commercial Grade Reliability",
    desc: "Built for continuous usage in demanding environments.",
  },
];

export default function FeaturesSection() {
  return (
    <section className="features" id="features">
      <div className="container">
        <p className="section-label reveal">
          Fast Charging Built for Space-Constrained Deployments
        </p>
        <h2 className="section-title reveal">Why Mini DC?</h2>
        <p className="section-sub reveal">
          VerdeMobility's Mini DC Fast Charger delivers rapid EV charging
          performance in a compact and deployment-friendly design — ideal for
          locations where space, uptime, and operational efficiency matter
          equally. Whether deployed for commercial fleets, retail parking,
          workplaces, or urban charging hubs, it enables reliable fast charging
          without requiring large infrastructure footprints.
        </p>
        <div className="features-grid">
          {features.map((f) => (
            <div className="feature-card reveal" key={f.title}>
              <div className="feature-icon">{f.icon}</div>
              <div className="feature-title">{f.title}</div>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
